import { PliAverage } from './pli-average';
import { PliValueType } from './pli-value-type';

export class PliValue extends PliAverage {
  pliValueId: number;
  taxYear: number;
  pliValueType: PliValueType;
}
